exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".org_auth .el-drawer__body{padding:20px}", ""]);

// exports
